import React from "react";

export default function CopyStep5() {
  return (
    <div>
      <div className="flex gap-2.5">
        <div className="shrink-0 border border-icon/50 w-8 h-8 rounded-full flex justify-center items-center text-lg font-semibold text-icon">
          5
        </div>
        <h1 className="">
          <b className="text-red-600 underline">ATENÇÃO:</b> Como a MAIA™ é uma
          <b> estratégia fechada</b> apenas para membros da Money Academy, é
          preciso inserir o código para liberar o seu acesso.
        </h1>
      </div>
      <div className="mt-2.5 ml-[42px] flex flex-col gap-1.5">
        <p>
          Para inserir o código, <b>clique em "INTRODUZA AQUI"</b>.
        </p>
        <img
          src="https://media.atomicatpages.net/u/0BVrOWOoOHYYehGtCMVYjXF1KZk1/Pictures/6f5kr/n2l5x/xXhfNd1377357.jpeg"
          className="w-72"
          alt=""
        />
      </div>
    </div>
  );
}
